export default __webpack_public_path__ + "static/enrico-dicorrado-864d316d8d9616fc39235ddd7df3b2ad.png";